import * as actions from "../actions/app";
import { deleteOrNop, pushSafe, setSafe } from "../util/storeHelper";
export const appReducer = {
    reducers: {
        [actions.setStateVersion]: (state, payload) => setSafe(state, ["version"], payload),
        [actions.setApplicationVersion]: (state, payload) => setSafe(state, ["appVersion"], payload),
        [actions.setExtensionEnabled]: (state, payload) => setSafe(state, ["extensions", payload.extensionId, "enabled"], payload.enabled),
        [actions.setExtensionVersion]: (state, payload) => setSafe(state, ["extensions", payload.extensionId, "version"], payload.version),
        [actions.setExtensionEndorsed]: (state, payload) => setSafe(state, ["extensions", payload.extensionId, "endorsed"], payload.endorsed),
        [actions.removeExtension]: (state, payload) => setSafe(state, ["extensions", payload, "remove"], true),
        [actions.forgetExtension]: (state, payload) => deleteOrNop(state, ["extensions", payload]),
        [actions.setInstanceId]: (state, payload) => setSafe(state, ["instanceId"], payload),
        [actions.setWarnedAdmin]: (state, payload) => setSafe(state, ["warnedAdmin"], payload),
        [actions.setInstallType]: (state, payload) => setSafe(state, ["installType"], payload),
        [actions.completeMigration]: (state, payload) => pushSafe(state, ["migrations"], payload),
    },
    defaults: {
        instanceId: undefined,
        version: "",
        appVersion: "",
        extensions: {},
        warnedAdmin: 0,
        migrations: [],
        installType: "official",
    },
    verifiers: {
        instanceId: {
            description: () => "No instance id set",
            type: "string",
        },
        version: {
            description: () => "Version not set",
            type: "string",
        },
        appVersion: {
            description: () => "Application version not set",
            type: "string",
        },
        extensions: {
            description: () => "Resetting list of disabled extensions",
            noUndefined: true,
        },
    },
};
